function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.87804 3.42021C3.36353 1.08302 6.19828 -0.141806 9.00004 0.504621C12.3031 1.2667 14.5079 4.3867 14.1234 7.75463C13.7389 11.1226 10.8876 13.6653 7.49781 13.6634C7.20937 13.6632 6.97567 13.4292 6.97584 13.1408C6.97601 12.8523 7.20998 12.6186 7.49842 12.6188C10.3569 12.6205 12.7613 10.4762 13.0856 7.63615C13.4098 4.79608 11.5506 2.16507 8.76521 1.52243C6.22926 0.937328 3.66126 2.17019 2.5026 4.42966H5.4507C5.73914 4.42966 5.97297 4.66349 5.97297 4.95193C5.97297 5.24037 5.73914 5.4742 5.4507 5.4742H1.35577C1.06733 5.4742 0.833496 5.24037 0.833496 4.95193V0.856995C0.833496 0.568552 1.06733 0.334723 1.35577 0.334723C1.64421 0.334723 1.87804 0.568552 1.87804 0.856995V3.42021Z",
  fill: "currentColor"
});

const SvgRefresh = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRefresh, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/refresh.455f858f.svg";
export { ForwardRef as ReactComponent };